<template>
  <div class="content">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <v-select v-model="filter.stackType" :items="stackTypes" item-text="text" item-value="value" @change="onSelect" class="mr-1" solo dense hide-details></v-select>
        <v-select v-model="filter.systemId" :items="stackSystems" item-text="text" item-value="value" @change="onSelect" class="mr-2" solo dense hide-details></v-select>
      </div>
    </v-card>
    <v-data-table :headers="headers" :items="cycles" item-key="code" :loading="loading" class="elevation-1 content" height="560px" dense fixed-header disable-pagination hide-default-footer>
      <template v-slot:top>
        <CycleForm :formData="formData" v-model="showForm" @change="onChange" />
      </template>

      <template v-slot:item.cycle="{ value }">
        {{ mis2Msms(value) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="editCycle(item)">mdi-pencil</v-icon>
          </template>
          <span>{{ $t('common.edit') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import { mis2Msms } from '@/utils/formatter';
import CycleForm from './CycleForm';

export default {
  components: {
    CycleForm,
  },
  data() {
    return {
      loading: false,
      showForm: false,
      formData: {},
      stackTypes: [
        { value: 'ABAP', text: 'ABAP Stack' },
        { value: 'JAVA', text: 'Java Stack' },
      ],
      systems: [],
      filter: {
        stackType: 'ABAP',
        systemId: '',
      },
      cycles: [],
    };
  },
  computed: {
    stackSystems() {
      const stackSystems = this.systems.filter(system => system.stackType === this.filter.stackType);
      stackSystems.unshift({ value: '', text: 'Default' });
      return stackSystems;
    },
    headers() {
      const headers = [
        { text: this.$t('cycle.target'), value: 'name', width: '70%', sortable: false },
        { text: this.$t('cycle.cycle'), value: 'cycle', sortable: false },
        { text: '', value: 'actions', width: '5%', sortable: false },
      ];

      if (this.filter.systemId) {
        headers.splice(1, 0, { text: this.$t('cycle.collectYn'), value: 'collect', sortable: false });
      }
      return headers;
    },
  },
  async created() {
    const { data } = await api.get('/preference/systems');
    this.systems = data.map(item => {
      return { value: item.id, text: item.id, stackType: item.stackType };
    });
    this.fetchCycles();
  },
  methods: {
    async fetchCycles() {
      this.startLoading();
      ({ data: this.cycles } = await api.get(`/preference/monitors/${this.filter.stackType}/${this.filter.systemId}`));
      this.finishLoading();
    },
    editCycle(cycle) {
      this.formData = cycle;
      this.openForm();
    },
    onSelect(value) {
      // stack type이 변경된 것이라면 하위 시스템의 값을 초기 값으로 변경
      if (this.stackTypes.some(s => s.value === value)) {
        this.filter.systemId = '';
      }
      this.fetchCycles();
    },
    onChange(cycle) {
      const index = this.cycles.findIndex(c => c.code === cycle.code);
      Object.assign(this.cycles[index], cycle);
    },
    openForm() {
      this.showForm = true;
    },
    startLoading() {
      this.loading = true;
    },
    finishLoading() {
      this.loading = false;
    },
    mis2Msms,
  },
};
</script>

<style scoped>
.content {
  width: 800px;
  height: 600px;
}
</style>
